const zipNavItems = [
  { to: '/zip', label: 'Home' },
  { to: '/zip/levels', label: 'Game Levels' },
  { to: '/zip/leaderboard', label: 'Leaderboard' },
  { to: '/zip/users', label: 'User Management' },
  { to: '/zip/daily', label: 'Daily Challenge' },
];

export default zipNavItems;
